
import { resolveUrl } from '@shared/lib/url'
import { AppRoute } from '@shared/config'

import { useLessonRecurringStore } from './recurring/store'
import { useLessonsStore } from './store'
import { useLessonRecurringApi } from '../../api/lessons/recurring.hook'
import { useLessonRecurringTrackApi } from '../../api/lessons/recurring-track.hook'
import { buildRecurringPayload } from './lesson-recurring'

interface LessonRecurringSubmitReturn {
  submitRecurring: (tutorId: number, availability?: number) => Promise<void>
}

const FULLY_AVAILABLE = 100

/**
 * Queues the creation and goes back to the Lessons tab, which rereads the list when the job reports on the
 * discipline channel. Leaving the form at once is also the duplicate-submit guard the endpoint does not have.
 */
export const useLessonRecurringSubmit = (): LessonRecurringSubmitReturn => {
  const route = useRoute()
  const store = useLessonRecurringStore()
  const lessonsStore = useLessonsStore()

  const disciplineId = route.params.id as string

  const submitRecurring = async (tutorId: number, availability: number = FULLY_AVAILABLE): Promise<void> => {
    if (store.isSubmitting) return

    const payload = buildRecurringPayload({
      startDate: store.getStartDate,
      days: store.getDays,
      finishType: store.getFinishType,
      occurrences: store.getOccurrences,
      lessons: store.getLessons,
      finishDate: store.getFinishDate,
    })

    if (availability < FULLY_AVAILABLE) {
      void useLessonRecurringTrackApi({
        disciplineId,
        payload: { start_date: payload.start_date, days: payload.days, tutor_id: tutorId, availability },
      })
    }

    const isQueued = await useLessonRecurringApi({
      disciplineId,
      payload: { ...payload, tutor_id: tutorId },
      onStart: () => store.setSubmitting(true),
      onFinish: () => store.setSubmitting(false),
    })

    if (!isQueued) return

    lessonsStore.setRecurringPendingId(Number(disciplineId))
    await navigateTo(resolveUrl(AppRoute.DisciplinesLessons, { id: disciplineId }) ?? '/')
  }

  return {
    submitRecurring,
  }
}
